import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import * as fields from 'components/common/fields';
import {AutoSuggestSelect} from 'components/common';
import * as validators from 'utils/validators';
import {makeForm, levelMap, studentSetReadingPeriodsMap, studentSetReadingPeriodOptions} from 'utils/common';
import {fetchSchools} from 'api';

class ClassroomForm extends React.Component {
  constructor(props) {
    super(props);
    this.fetchSchools = this.fetchSchools.bind(this);
  }

  fetchSchools(value) {
    return fetchSchools(value).then(({records}) => records);
  }

  render() {
    const {schoolId, isUpdate, handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={isUpdate ? 12 : 6}>
            <Field name="name" label="Name" component={fields.Input} required validate={[validators.isRequired]} />
          </Col>
          {!isUpdate && !schoolId && (
            <Col md={6}>
              <AutoSuggestSelect
                name="school"
                label="School"
                labelKey="name"
                valueKey="id"
                onSearch={this.fetchSchools}
                required
                validate={[validators.isRequired]}
              />
            </Col>
          )}
          <Col md={6}>
            <Field
              name="level"
              label="App Level"
              labelKey="label"
              valueKey="value"
              component={fields.Select}
              options={[
                {value: 1, label: 'Yellow'},
                {value: 2, label: 'Green'},
                {value: 3, label: 'Orange'},
              ]}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="studentSetReadingPeriod"
              label="Students adding/editing readings"
              labelKey="label"
              valueKey="value"
              component={fields.Select}
              options={studentSetReadingPeriodOptions}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = {
  Creation: () => {
    return {
      initialValues: {
        studentSetReadingPeriod: {value: 3, label: studentSetReadingPeriodsMap[3]},
      },
    };
  },
  Update: (state) => {
    const currentClassroom = state.classrooms.get('currentClassroom').toJS();
    return {
      initialValues: {
        ...currentClassroom,
        level: {value: currentClassroom.level, label: levelMap[currentClassroom.level]},
        studentSetReadingPeriod: {
          value: currentClassroom.studentSetReadingPeriod,
          label: studentSetReadingPeriodsMap[currentClassroom.studentSetReadingPeriod] || 'No time frame',
        },
      },
    };
  },
};

export default {
  Creation: makeForm(ClassroomForm, 'ClassroomForm.Creation', mapStateToProps.Creation, null),
  Update: makeForm(ClassroomForm, 'ClassroomForm.Update', mapStateToProps.Update, null),
};
